import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ADD_NEW_PATH_1, ADD_NEW_PATH_2 } from '../../svg-shapes';

@Component({
  selector: 'vi-add-new-icon',
  templateUrl: './add-new-icon.component.html',
  styleUrls: ['./add-new-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AddNewIconComponent {
  public readonly ADD_NEW_PATH_1 = ADD_NEW_PATH_1;
  public readonly ADD_NEW_PATH_2 = ADD_NEW_PATH_2;
}
